import { createSlice } from "@reduxjs/toolkit";

const keyStrokeSlice = createSlice({
  name: "keyStrokeSlice",
  initialState: {
    screenshotData: null,
  },
  reducers: {
    setScreenshotData: (state, action) => {
      state.screenshotData = action?.payload;
    },
    clearNudity: (state, action) => {
      state.screenshotData = null
    }
  },
});

// this is for dispatch
export const { screenshotData, clearNudity } = keyStrokeSlice.actions;

// this is for configureStore
export default keyStrokeSlice.reducer;
